import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom';

import { Button } from 'components'
import { FaRegCopyright, FaLinkedin, FaInstagramSquare, FaMedium } from 'react-icons/fa'

import classes from './Footer.module.css'

const Container = styled.div`
    /* margin: 0 8rem; */
    padding: 0.25rem 0;
    /* border-top: 2px solid #474747; */
    /* border-style: solid;
    border-width: 2px 2px 0 2px;
    border-color: rgba(71, 71, 71, 0.50); */
    /* background-color: #957fef; */
    /* border-radius: 10px 10px 0 0; */
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 1100px) {
        margin: 0 2rem;
    }
`

const Divider = styled.div`
    margin: 0.1rem;
    border: 1px solid #999999;
    height: 1rem;
    border-radius: 5px;
    align-self: center;
`


const Body = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    background-color: '#474747';
    font-size: 1rem;
    width: max-content;
    justify-self: center;
`

const Footer = props => {
    let history = useHistory()
    const footerStyle = {
        backgroundColor: '#2B2B2B',
        boxShadowColor: 'transparent',
        margin: 0,
        fontSize: '0.9rem'
    }

    return (
        <Container>
            <Body>
                <FaRegCopyright style={{fontSize: '0.9rem'}}/>
                <span style={{margin: '0 0.5rem 0 0.2rem', fontSize: '0.9rem'}}>Atomicly</span>
                <Divider/>
                <Button text='Terms' styles={footerStyle} onSelect={() => history.push('/legal/terms-of-service')}/>
                <Button text='Privacy' styles={footerStyle} onSelect={() => history.push('/legal/privacy-policy')}/>
                <Divider/>
                {/* <Button tooltip='LinkedIn' icon={<FaLinkedin/>} styles={footerStyle} onSelect={() => window.open('http://www.google.com')}/>
                <Button tooltip='Instagram' icon={<FaInstagramSquare/>} styles={footerStyle} onSelect={() => window.open('http://www.google.com')}/> */}
                <Button tooltip='Medium' icon={<FaMedium/>} styles={footerStyle} onSelect={() => window.open('http://www.medium.com')}/>
            </Body>
        </Container>
    )
}

export default Footer